<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex xs12 sm6 md4 v-for="(one, index) in all" :key="index">
          <v-card
            @click="$router.push(one.route)"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:orange;color:black;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:200%;;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <!-- <v-icon style="margin:0 10px;color:blue;font-size:40px"
                >{{ one.icon }}
              </v-icon> -->
             {{ one.name }}
            </v-card-title>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      all:[
        {name:'التحكم',icon:'dashboard',route:'/DashboardDetails'},
        {name:'المخازن',icon:'storefront',route:'/StoreOperationDetails'},
        {name:'المبيعات',icon:'ballot',route:'/SalesDetails'},
        {name:'المشتريات',icon:'insert_invitation',route:'/BuyDetails'},
        {name:'الخزينة',icon:'money',route:'/KhazinaDetails'},
        {name:'البنوك',icon:'business',route:'/BankDetails'},
        {name:'HR',icon:'supervisor_account',route:'/HrDetails'},
        {name:'كشوف الحسابات',icon:'notes',route:'/AccountDetails'},
        {name:'تقارير المبيعات',icon:'notes',route:'/SalesReportDetails'},
        {name:'تقارير المخازن',icon:'notes',route:'/StorereportDetails'},
        {name:'تقارير الخزينة',icon:'notes',route:'/KhazinaReportDetails'},
        {name:'تقارير الادارة',icon:'notes',route:'/ManageReportDetails'},
        {name:'تقارير الموظفين',icon:'notes',route:'/EmployerReportDetails'},
        {name:'تقارير الموردين',icon:'notes',route:'/ImporterReportDetails'},
        {name:'تقارير المرتجعات',icon:'notes',route:'/RebackReportDetails'}

      ]
    };
  },
  methods: {
    yes() {
      // this.$toastr.warning
      // this.$toastr.success
      // this.$toastr.info
      // this.$toastr.error
      let mytitle = "رسالة ترحيب";
      let mybody = "أهلا بك في برنامج اكوريت الحديث ";
      this.$toastr.info(mybody, mytitle, {
        closeButton: true,
        debug: true,
        newestOnTop: false,
        progressBar: true,
        positionClass: "toast-bottom-left",
        preventDuplicates: false,
        onclick: null,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "25000",
        extendedTimeOut: "1000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut"
      });
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.yes();
  }
};
</script>
